export const getErrorMessage = (errorMessage) => {
  switch (errorMessage) {
    case "Account with this email/username does not exist":
      return "Couldn't find your account!";
    case "Unable to log in with provided credentials.":
      return "Wrong password!";
    case "provided email address is not verified":
      return "Provided email address is not verified!";
    // Social Auth specific errors
    case "Invalid Google access token":
      return "Google authentication failed. Please try again.";
    case "Google authentication failed":
      return "Unable to authenticate with Google. Please try again.";
    case "Account linking failed":
      return "Failed to link your Google account. Please try again.";
    case "Invitation acceptance failed":
      return "Failed to accept invitation. Please contact your organization.";
    case "Invalid or expired invitation token":
      return "This invitation link is invalid or has expired.";
    default:
      return "An unexpected error occurred. Please try again.";
  }
};

export const getErrorContext = (errorMessage) => {
  switch (errorMessage) {
    case "Account with this email/username does not exist":
      return { field: "email", message: "Couldn't find your account!" };
    case "Unable to log in with provided credentials.":
      return { field: "password", message: "Wrong password!" };
    case "provided email address is not verified":
      return { field: "email", message: "Provided email address is not verified!" };
    // Social Auth specific errors
    case "Invalid Google access token":
      return { field: "generic", message: "Google authentication failed. Please try again." };
    case "Google authentication failed":
      return { field: "generic", message: "Unable to authenticate with Google. Please try again." };
    case "Account linking failed":
      return { field: "generic", message: "Failed to link your Google account. Please try again." };
    case "Invitation acceptance failed":
      return { field: "generic", message: "Failed to accept invitation. Please contact your organization." };
    case "Invalid or expired invitation token":
      return { field: "generic", message: "This invitation link is invalid or has expired." };
    default:
      return { field: "generic", message: "An unexpected error occurred. Please try again." };
  }
};
